import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseStoreFacade } from '@city/data-access';
import { MenuNestedService } from '@core/data-access';
import { ChatLinksDataAnalytics } from '@main/online-chats/const';
import { PhoneService } from '@main/phone/data-access';
import { DeviceService } from '@shared/services';
import { map, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ReplacePipe } from '../../../pipes';

@Component({
  selector: 'sd-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
  imports: [AsyncPipe, ReplacePipe, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneComponent implements OnInit {
  isDesktopLgUp$ = this.deviceService.isDesktopLgUp$;
  telegramLink$: Observable<string | undefined>;
  phone$: Observable<string>;

  constructor(
    private destroyRef: DestroyRef,
    private phoneService: PhoneService,
    private deviceService: DeviceService,
    private baseStoreFacade: BaseStoreFacade,
    private menuNestedService: MenuNestedService,
  ) {}

  ngOnInit(): void {
    this.phone$ = this.phoneService.getPhone();

    this.baseStoreFacade
      .getActiveCode()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((baseStoreCode) => {
        this.phoneService.loadPhone(baseStoreCode);
        this.menuNestedService.loadMenuBySlug('messenger-links', baseStoreCode);
      });

    this.telegramLink$ = this.menuNestedService.getMenuBySlugValue('messenger-links').pipe(
      filter(Boolean),
      map(
        (messengers) =>
          messengers.filter((messenger) => messenger.title.toLowerCase() === ChatLinksDataAnalytics.telegram)?.[0]?.url,
      ),
    );
  }
}
